import { useNavigate } from 'react-router-dom';
import supabase from '../supabaseClient';
import { Inp, Btn } from './ui/FormControls';

// ── OPERADOR: LLEGADA ────────────────────────────────────────────
export const LlegadaSection = ({ llegada, setLlegada, currentUser }) => {
  const navigate = useNavigate();
  return (
  <div className="space-y-4">
    <div className="bg-white rounded-xl shadow p-4 space-y-4">
      <h2 className="font-bold text-gray-800 border-b pb-2">🚚 Registro de Llegada</h2>
      <p className="text-xs text-gray-500">Rellena los datos de tu llegada a las instalaciones.</p>
      <Inp label="Nombre del conductor *" value={llegada.nombre_conductor} onChange={v => setLlegada(s => ({ ...s, nombre_conductor: v }))} placeholder="Nombre completo" />
      <Inp label="Empresa / Transportista *" value={llegada.empresa} onChange={v => setLlegada(s => ({ ...s, empresa: v }))} placeholder="Nombre de la empresa" />
      <Inp label="Matrícula del vehículo *" value={llegada.matricula} onChange={v => setLlegada(s => ({ ...s, matricula: v }))} placeholder="0000-AAA" />
      <Inp label="Hora de llegada *" type="datetime-local" value={llegada.hora_llegada} onChange={v => setLlegada(s => ({ ...s, hora_llegada: v }))} />
      <Btn onClick={async () => {
        try {
          const { error: rError } = await supabase.from('registro_llegadas').insert({ ...llegada, hora_llegada: new Date(llegada.hora_llegada).toISOString(), almacen_id: currentUser?.almacen_id });
          if (!rError) {
            setLlegada({ nombre_conductor: "", empresa: "", matricula: "", hora_llegada: "" });
navigate("/app/llegada-confirmada");
            fetch("https://fmzyvyhgqhrpfpsdwtcu.supabase.co/functions/v1/enviar-notificacion", {
              method: "POST",
              headers: { "Content-Type": "application/json", "Authorization": `Bearer ${process.env.REACT_APP_SB_KEY}` },
              body: JSON.stringify({ tipo: "Registro Llegada", nombre: llegada.nombre_conductor, equipo: llegada.matricula, observaciones: `Empresa: ${llegada.empresa}`, fecha: new Date().toLocaleDateString("es-ES"), hora: new Date().toLocaleTimeString("es-ES", { hour: "2-digit", minute: "2-digit" }), almacen_id: currentUser?.almacen_id })
            });
          }
        } catch { }
      }} disabled={!llegada.nombre_conductor || !llegada.empresa || !llegada.matricula || !llegada.hora_llegada}>
        Registrar llegada →
      </Btn>
    </div>
  </div>
  );
};
